import React from 'react';
import { PropTypes } from 'prop-types';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Row, InfoContainer, MobileSpacer, GraphAutoComplete, FormElements, Grid } from '@custom-components';
import { SUPPLIER_CHAIN_CODE } from '@containers/AutoCompleteContainer/gql';

function StandardConfiguration(props) {
  const { mainForm, handleChangeAttribute, handleEditAttributeAutoComplete } = props;
  const totalAttributes = 3;
  const roomCodeOptions = [
    {
      label: 'Primary',
      value: true
    },
    {
      label: 'Secondary',
      value: false
    }
  ];

  const handleAutoComplete = (element) => {
    const selectedGql = {};

    // In case we need more Autocomplete components in the future
    switch (element.toLowerCase()) {
      // Chain Code
      default:
        selectedGql.accessString = 'SupplierQueries.chainCodeTypeahead';
        selectedGql.query = SUPPLIER_CHAIN_CODE;
        selectedGql.mapper = (data) =>
          data.map((item) => ({
            label: item.sabreChainName,
            value: item.sabreChainCode
          }));
        selectedGql.variables = (value) => ({ chainName: value.query });
        break;
    }
    return selectedGql;
  };

  const getAutoCompleteValue = (autoValue) =>
    Object.keys(autoValue.query).length <= 0 && mainForm.values.connectionAttributes.ChainCode !== undefined
      ? { query: mainForm.values.connectionAttributes.ChainCode.complement.value }
      : autoValue;

  const validationSchema = () =>
    yup.object().shape({
      hotelCode: yup.string().required('Please insert an hotel code'),
      chainCode: yup.string().required('Please select a hotel chain')
    });

  const initialValues = () => ({
    chainCode: '',
    chain: {
      value: '',
      query: ''
    }
  });

  return (
    <div style={{ marginTop: '5%' }}>
      <InfoContainer leftSubBarContents={[{ type: 'label', props: { label: 'Please add the following attributes:' } }]}>
        <div key="HotelCode" style={{ marginTop: '.5%' }}>
          <Row>
            <Grid.Col lg={12}>
              <FormElements.TextInput
                name="HotelCode"
                key="HotelCode"
                label="Hotel Code"
                value={
                  mainForm.values.connectionAttributes.HotelCode !== undefined
                    ? mainForm.values.connectionAttributes.HotelCode.value
                    : ''
                }
                onBlur={mainForm.handleBlur}
                onChange={(item) => handleChangeAttribute(mainForm, item, 'Hotel Code', 'Input', totalAttributes)}
                required
              />
            </Grid.Col>
          </Row>
        </div>
        <div key="ChainCode" style={{ marginTop: '5%' }}>
          <Row>
            <Formik initialValues={initialValues()} validationSchema={validationSchema()}>
              {({ errors, values, submitCount, setFieldValue }) => (
                <>
                  <Grid.Col sm={12} md={6}>
                    <GraphAutoComplete
                      name="ChainName"
                      value={getAutoCompleteValue(values.chain)}
                      label="Chain Name (typeahead)"
                      setFieldValue={(n, fieldVal) => {
                        setFieldValue('chain', fieldVal);
                        if (fieldVal.query === '') {
                          setFieldValue('chainCode', '');
                          handleEditAttributeAutoComplete(mainForm, 'ChainCode');
                        }
                      }}
                      onValueChange={(n, val) => {
                        setFieldValue('chainCode', val.value);
                        setFieldValue('chain', val);

                        const item = {
                          target: { value: val.value, complement: { name: 'Chain Name', value: val.query } }
                        };
                        handleChangeAttribute(mainForm, item, 'Chain Code', 'Auto', totalAttributes);
                      }}
                      graphql={handleAutoComplete('ChainCode')}
                      variant="standard"
                      error={!!errors.chainCode && submitCount > 0}
                      errorText={errors.chainCode ? errors.chainCode : ''}
                      characterLimit={2}
                      required
                    />
                  </Grid.Col>
                  <MobileSpacer lessThan="md" />
                  <Grid.Col sm={12} md={6}>
                    <FormElements.TextInput
                      name="ChainCode"
                      label="Chain Code (auto)"
                      value={
                        Object.keys(values.chainCode).length <= 0 &&
                        mainForm.values.connectionAttributes.ChainCode !== undefined
                          ? mainForm.values.connectionAttributes.ChainCode.value
                          : values.chainCode
                      }
                      disabled
                    />
                  </Grid.Col>
                </>
              )}
            </Formik>
          </Row>
        </div>
        <div key="RoomCodeType" style={{ marginTop: '5%' }}>
          <Row>
            <Grid.Col lg={12}>
              <FormElements.Select
                variant="outlined"
                id="RoomCodeType"
                key="RoomCodeType"
                name="RoomCodeType"
                label="Select Room Code Type"
                value={
                  mainForm.values.connectionAttributes.RoomCodeType !== undefined
                    ? mainForm.values.connectionAttributes.RoomCodeType.value
                    : ''
                }
                options={roomCodeOptions}
                onBlur={mainForm.handleBlur}
                onChange={(item) => {
                  const option = {
                    target: {
                      value: item.target.value,
                      label: roomCodeOptions[roomCodeOptions.findIndex((e) => e.value === item.target.value)].label
                    }
                  };
                  handleChangeAttribute(mainForm, option, 'Room Code Type', 'Select', totalAttributes);
                }}
                inputProps={{ readOnly: true }}
                required
              />
            </Grid.Col>
          </Row>
        </div>
      </InfoContainer>
    </div>
  );
}

StandardConfiguration.propTypes = {
  mainForm: PropTypes.shape({
    values: {
      connectionAttributes: PropTypes.shape({})
    },
    errors: {
      connectionAttributes: PropTypes.string
    },
    handleBlur: PropTypes.func
  }),
  handleChangeAttribute: PropTypes.func,
  handleEditAttributeAutoComplete: PropTypes.func
};

StandardConfiguration.defaultProps = {
  mainForm: {},
  handleChangeAttribute: () => {},
  handleEditAttributeAutoComplete: () => {}
};

export default StandardConfiguration;
